import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiUrl, setAdminToken } from '../../api';
import './Admin.css';

function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(apiUrl('/api/admin/login'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        setError(data.message || 'Login failed');
        return;
      }
      if (data.token) setAdminToken(data.token);
      localStorage.setItem('admin', JSON.stringify(data.admin));
      navigate('/admin');
    } catch (err) {
      setError('Could not reach the server. Is it running?');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-wrap">
      <form className="admin-login-card" onSubmit={handleSubmit}>
        <h1 className="admin-login-title">Elaichi &amp; Love</h1>
        <p className="admin-login-sub">Admin Portal</p>

        {error && <div className="admin-error">{error}</div>}

        <label className="admin-label">Email</label>
        <input
          className="admin-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="admin@elaichilove.com"
          required
        />

        <label className="admin-label">Password</label>
        <input
          className="admin-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password"
          required
        />

        <button className="admin-btn-primary" type="submit" disabled={loading}>
          {loading ? 'Signing in…' : 'Log In'}
        </button>
      </form>
    </div>
  );
}

export default AdminLogin;
